import React from 'react'
import { PlanSeq } from '@mobi/api-types'
import type { BetLoopShareTicket } from '@core/Areas/BetLoop/types'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import { SingleSingle, SingleMultiple, Multi, FavouriteNumbers, SameRaceMulti } from './Components'
import { getTicketLayoutType } from '@core/Areas/AccountActivity/Components/Ticket/helpers'

export const SelectionInfo: React.FC<{ ticket: Ticket | BetLoopShareTicket }> = ({ ticket }) => {
  if (PlanSeq.FavouriteNumbers === ticket.planSeq) return <FavouriteNumbers ticket={ticket} />

  const ticketLayoutType = getTicketLayoutType(ticket)

  if (ticketLayoutType === 'same-race-multi') return <SameRaceMulti ticket={ticket} />

  if (ticketLayoutType === 'single-single') return <SingleSingle leg={ticket.legs[0]} />

  if (ticketLayoutType === 'single-multiple') {
    return <SingleMultiple ticket={ticket} />
  }

  if (ticketLayoutType === 'multi' || ticketLayoutType === 'tipping')
    return <Multi ticket={ticket} ticketLayoutType={ticketLayoutType} />

  return null
}
